import { useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import api from '../lib/api';

// design/036 — a suspended account can still sign in, but only sees this:
// why, how to get help, and Sign out / Delete account. Nothing else in the
// app is reachable (the server refuses every other call).
export default function SuspendedPage() {
  const { me, signOut } = useAuth();
  const [busy, setBusy] = useState(false);
  const provider = me?.subscription?.provider;
  const storeSub = provider === 'APPLE' || provider === 'GOOGLE';

  const del = async () => {
    if (!window.confirm('Delete your account and all your data? This cannot be undone.')) return;
    setBusy(true);
    try { await api.deleteMe(); await signOut(); }
    catch (e) { alert(e.message); setBusy(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, background: 'var(--bg, #f6f7fb)' }}>
      <div className="card" style={{
        maxWidth: 520, width: '100%', background: '#fff', border: '1px solid var(--border, #e5e7eb)',
        borderRadius: 14, padding: 28, lineHeight: 1.55,
      }}>
        <h1 style={{ marginTop: 0, fontSize: '1.5rem' }}>Your account has been suspended</h1>
        {me?.suspendedReason
          ? <p><b>Reason:</b> {me.suspendedReason}</p>
          : <p>An administrator has suspended your account.</p>}
        <p>Your web subscription won't renew.{storeSub
          ? ` You subscribed through ${provider === 'APPLE' ? 'the App Store' : 'Google Play'} — cancel it in your ${provider === 'APPLE' ? 'Apple ID' : 'Google Play'} subscription settings to stop being charged.`
          : ''}</p>
        <p style={{ color: 'var(--muted, #6b7280)' }}>
          If you think this is a mistake, email <a href="mailto:support@mediumnumber.com">support@mediumnumber.com</a>.
        </p>
        <div style={{ display: 'flex', gap: 10, marginTop: 20, flexWrap: 'wrap' }}>
          <button className="btn" disabled={busy} onClick={() => signOut()}>Sign out</button>
          <button className="btn btn-danger" disabled={busy} onClick={del}>{busy ? 'Deleting…' : 'Delete account'}</button>
        </div>
      </div>
    </div>
  );
}
